import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { AccessTokens } from '@models/models';

enum OauthClient {
	WEB = 'Basic U05fV0VCOndlYlBhc3M=',
	WEB_STLG = 'Basic U05fV0VCX1NUTEc6d2ViUGFzcw=='
}

export class AuthTokensService {
	isRefreshingToken: boolean;
	tokenSubject: BehaviorSubject<string> = new BehaviorSubject(null);

	isRefreshingInProcess() {
		return this.isRefreshingToken;
	}

	setRefreshingInProcess(value: boolean) {
		this.isRefreshingToken = value;
	}

	get tokenSubject$(): Observable<string> {
		return this.tokenSubject.asObservable();
	}

	emitTokenSubject(value: string): void {
		return this.tokenSubject.next(value);
	}

	setAuthToken(token: string): void {
		localStorage.setItem('authToken', token);
	}

	setRefreshToken(token: string): void {
		localStorage.setItem('refreshToken', token);
	}

	getAuthToken(): string {
		return localStorage.getItem('authToken');
	}

	getRefreshToken(): string {
		return localStorage.getItem('refreshToken');
	}

	removeTokens(): void {
		localStorage.removeItem('authToken');
		localStorage.removeItem('refreshToken');
	}

	isToken(url: string, token: string): boolean {
		return (
			this.shouldRequestBeAuthorised(url) &&
			typeof token !== 'undefined' &&
			token !== null
		);
	}

	successGetRefreshedToken(data: AccessTokens): string {
		const { access_token, refresh_token } = data;
		this.removeTokens();
		this.setAuthToken(access_token);
		this.setRefreshToken(refresh_token);
		return access_token;
	}

	getCorrectBasicWebToken(): string {
		const logIn = localStorage.getItem('isStayLogin');
		let basicToken = OauthClient.WEB;
		if (logIn === null) {
			location.href = '/login';
		} else if (logIn === 'true') {
			basicToken = OauthClient.WEB_STLG;
		}
		return basicToken;
	}

	private shouldRequestBeAuthorised(url: string): boolean {
		const protectedRequestStart = '/protected/rest';
		const protectedBaseStart = '/protected_base/rest';
		const apiRequestsStart = '/api';
		const apiPublicRequestsStart = '/api/public';
		const restRequestStart = '/rest';
		const revokeTokenRequest = '/oauth/revoke';
		const adminRequestsStart = '/admin';

		return (
			(url &&
				(url.includes(protectedRequestStart) ||
					url.includes(restRequestStart) ||
					url.includes(protectedBaseStart) ||
					(url.includes(apiRequestsStart) &&
						!url.includes(apiPublicRequestsStart)) ||
					url.includes(revokeTokenRequest))) ||
			url.startsWith(adminRequestsStart)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/auth-tokens.service.ts